import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import GoogleReviews from "@/components/feature/GoogleReviews";
import RealisationsGallery from "./components/RealisationsGallery";
import ContactForm from "./components/ContactForm";
import FloatingButton from "./components/FloatingButton";

export default function AvisPage() {
  useSEO(seoData.avis);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <GoogleReviews />
        <RealisationsGallery />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}